let Buttons;

Buttons = (() => {
  function Buttons() {
    $(".multi-step").on("click", function(e) {
      let $this;
      let nextStep;
      e.preventDefault();
      $this = $(this);
      nextStep = $this.attr("href");
      if ($(nextStep).length > 0) {
        $(this).removeClass("visible").addClass("hidden");
        return $(nextStep).removeClass("hidden").addClass("visible");
      } else {
        return window.location = nextStep;
      }
    });
    $(".button.button-process").on("click", function(e) {
      let $this;
      $this = $(this);
      $this.toggleClass("processing");
      return setTimeout(
        () => {
          $this.removeClass("processing").addClass("success");
          return setTimeout(() => $this.removeClass("success"), 3000);
        },
        10000,
      );
    });
  }

  return Buttons;
})();

export default Buttons;
